import { WorkerResponse, WorkersResponse, WorkersTypes, WorkersStatuses } from '../Interfaces/Workers.interfaces';
import { del, get, post, put } from './api.service';

const base_url = 'workers/v1';

type GetAllParams = {
    page?: number,
    per_page?: number,
    search?: string,
    type?: WorkersTypes,
    status?: WorkersStatuses,
    order?: string,
    table_id?: number | string,
    with_relationship?: string,
    with_table?: string,
};



/** Get workers of any type */
export function getAll(params: GetAllParams & {
    type?: undefined;
}): Promise<WorkersResponse>;

/** Get workers of the specific {@link WorkersType} */
export function getAll<WorkersType = WorkersTypes>(params: GetAllParams & {
    type: WorkersType;
}): Promise<WorkersResponse<WorkersType>>;

/** Get all workers */
export function getAll(params: GetAllParams = {}) {
    const queryString = Object.keys(params)
        .filter(key => params[key as keyof typeof params])
        .map(key => {
            return `${key}=${params[key as keyof typeof params]}`;
        }).join('&');

    let url = queryString ? base_url + `?${queryString}` : base_url;

    return get<WorkersResponse<Exclude<typeof params.type, undefined>>>(url);
}



export const getById = (id: number, params: {
    with_relationship?: string
} | undefined = undefined) => {
    const queryString = Object.keys(params || {})
        .filter(key => (params || {})[key as keyof typeof params])
        .map(key => {
            return `${key}=${(params || {})[key as keyof typeof params]}`;
        }).join('&');
 
    let url = queryString ? `${base_url}/${id}` + `?${queryString}` : `${base_url}/${id}`;
 
    return get<WorkerResponse>(url);
}

export const create = (data: object) => {
    return post(base_url, data);
}

export const update = (data: { values: object, id: number }) => {
    return put(`${base_url}/${data.id}`, data.values);
}

export const remove = (id: number | undefined) => {
    return del(`${base_url}/${id}`);
}
